// src/components/layout/AppLayout.tsx
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingSocialMedia from "./FloatingSocialMedia";
import FlashMessage from "./FlashMessage"; // MUI Snackbar wrapper
import { useUserContext } from "@/context/UserContext";
// import Breadcrumb from "../Breadcrumb";     // <-- import your Breadcrumb component

const AppLayout: React.FC = () => {
  const [flash, setFlash] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "info" | "warning" | "error";
  }>({
    open: false,
    message: "",
    severity: "info",
  });

  // Expose a helper to children via Outlet context
  const showFlash = (
    message: string,
    severity: "success" | "info" | "warning" | "error" = "info"
  ) => {
    setFlash({ open: true, message, severity });
  };
  const { basicData } = useUserContext();
  // console.log("BASIC DATA:",basicData);
  const effectiveUserType =
    (
      localStorage.getItem("authUserType") ??
      basicData?.user_type ??
      "INDIVIDUAL"
    ).toUpperCase();
  const userMode = basicData?.role_name == "Admin" ? "ADMIN" : "USER"

  let userTypeLabel = '';

  switch (effectiveUserType) {
    case ("INDIVIDUAL"): userTypeLabel = "Career Development Programs"; break;
    case ("ACADEMIC"): userTypeLabel = "Academic Programs"; break;
    case ("CORPORATE"): userTypeLabel = "Corporate Services"; break;
  }
  return (
    <div className="min-h-screen flex flex-col bg-gray-300">
      <Header />

      {basicData?.name && (
        <div className="bg-green-50 p-2">
          Welcome <span className="font-bold"> {basicData.name} </span>
          {userMode === "USER" ? (
            <>  [{" "} {basicData.email}]{" "}[{userTypeLabel}{" "} ]</>
          ) :
            (
              <>  [Admin]</>
            )}
        </div>
      )}

      {/* Breadcrumb always visible below Header */}
      {/* <div className="px-6 py-2 bg-gray-50 border-b">
        <Breadcrumb />
      </div> */}

      <main className="flex-1 p-4">
        {/* ✅ children routes will render here */}
        <Outlet context={{ showFlash }} />
      </main>

      <Footer />

      {/* Persistent floating widget */}
      <FloatingSocialMedia />

      {/* Flash message snackbar */}
      <FlashMessage
        open={flash.open}
        message={flash.message}
        severity={flash.severity}
        onClose={() => setFlash({ ...flash, open: false })}
      />
    </div>
  );
};

export default AppLayout;